import { validateCEP } from 'utils/validation/validators'

type ValidateCEPOnCustomFormParams = {
  cep: string
  isRequired?: boolean
}

export default function validateCEPOnCustomForm({ cep, isRequired }: ValidateCEPOnCustomFormParams) {
  const cepValue = Array.isArray(cep) ? cep[0] : cep
  let error = ''
  if (isRequired && cepValue === '') {
    error = 'Este campo é obrigatório'
  }
  if (cepValue && !validateCEP(cepValue)) {
    error = 'Este CEP está incorreto.'
  }

  return error
}
